import { useNavigate } from "react-router-dom";
import IDlogo from "../../assets/images/NBAID.svg";
import SeeAll from "../../assets/images/seeall.svg";
import "../../assets/css/challenges.css";

function CompletedChallengeCard(props) {
    console.log(props, "completed-card");
    const navigate = useNavigate();
    const pctCompleted = props && props.challenge && props.challenge.activities && props.challenge.activities.length > 0 ?
        props.challenge.activities.filter(activity => activity.activityHistory && activity.activityHistory.length > 0).length / props.challenge.activities.length : 0;

    return (
        <div id={props.challenge.id} className="completed-challenge-card" onClick={() => {
                if (pctCompleted === 1) {
                    navigate(`/challenges/${props.challenge.activity_id}`);
                }
            }}>
            <div className="challenge-body" style={{ backgroundImage: `url(${props.challenge.base_extra_data.BackgroundImage})` }}>
                <div className="top-img-row">
                    <img className="nbaid-logo" src={IDlogo} alt="" />
                </div>
                <div className="challenge-header mobile">
                    <div className="challenge-image">
                        <div className="earned-background" style={{ backgroundImage: `url(${props.challenge.image})` }}>
                            <div className="unearned-image" style={{ height: `calc(158px * ${1 - pctCompleted})` }}>
                                <img src={props.challenge.image} alt="" />
                            </div>
                        </div>
                    </div>
                    {/*props.challenge.base_extra_data.Partner_logo && <div className="presented-by">
                        Presented by
                        <img className="sponsor-logo" src={props.challenge.base_extra_data.Partner_logo}/>
                    </div>*/}
                </div>
                <div className="challenge-text">
                    <div className="challenge-title">{props.challenge.title}</div>
                    <div className="challenge-desc">{`Ended
                            ${new Intl.DateTimeFormat("en-US", { month: "long" }).format(props.challenge.date_end * 1000)}
                            ${(new Date(props.challenge.date_end * 1000)).getFullYear()}`}</div>
                </div>
                <div className="challenge-header">
                    <div className="challenge-image">
                        <div className="earned-background" style={{ backgroundImage: `url(${props.challenge.image})` }}>
                            <div className="unearned-image" style={{ height: `calc(158px * ${1 - pctCompleted})` }}>
                                <img src={props.challenge.image} alt="" />
                            </div>
                        </div>
                    </div>
                    {/*props.challenge.base_extra_data.Partner_logo && <div className="presented-by">
                        Presented by
                        <img className="sponsor-logo" src={props.challenge.base_extra_data.Partner_logo}/>
                    </div>*/}
                </div>
            </div>
            <div className="challenge-status">
                {pctCompleted !== 1 ?
                    <div>Unearned&nbsp;&nbsp;&nbsp;</div>
                    :
                    <>
                        <div>Earned&nbsp;&nbsp;&nbsp;•</div>
                        <div className="view-details-cta">Share Your Badge <img alt="See All" src={SeeAll}></img></div>
                    </>
                }
            </div>
        </div>
    );
}

export default CompletedChallengeCard;
